export default __webpack_public_path__ + "static/elf-example-2-eb313cbb50ef0b3ff3ff4e002a5fed0a.png";